export default __webpack_public_path__ + "static/media/step-2.d12a50ea.png";